import React, { useEffect, useState } from 'react';

const ENV = process.env.REACT_APP_ENV;

export default function ArcadiaIFrame(props) {
  const { organizationId, iframe_key, } = props;

  const [iframeURL, setURL] = useState(null);

  useEffect(() => {
    let url = `https://arc-connect.arcadia.com/${iframe_key}?correlationId=${organizationId}&primaryColor=%23195E88`;
    if (!['prod', 'staging'].includes(ENV)) {
      url = url + '&apiMode=sandbox';
    }

    setURL(url);
  }, [organizationId, iframe_key]);

  return (
    <>
      {organizationId && iframe_key && iframeURL ? (
        <iframe
          style={{ width: '100%', border: 'none' }}
          title='utilityAccountLoginInfo'
          src={iframeURL}
          width='780x'
          height='650px'
        />
      ) : (
        <></>
      )}
    </>
  );
}
